var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.url
      ? _c(
          "a",
          {
            staticClass: "call-to-action-button btn",
            class: _vm.reverseColors
              ? _vm.reverseColorCssClass
              : _vm.mainColorCssClass,
            attrs: {
              href: _vm.url,
              target: _vm.openURLInNewTab ? "_blank" : "_self"
            }
          },
          [
            _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
            _vm.reverseColors
              ? _c("span", {
                  class:
                    "png-icon png-icon-" +
                    (_vm.iconName
                      ? _vm.iconName
                      : _vm.reverseColorDefaultIconName)
                })
              : _c("span", {
                  class:
                    "png-icon png-icon-" +
                    (_vm.iconName ? _vm.iconName : _vm.mainColorDefaultIconName)
                })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }